import {get} from 'lodash';

import {chartSlice} from './chart_slice';
import {AppThunk} from 'src/js/store';

export function loadChartConfig(stateId, configPath): AppThunk {
  return (dispatch, getState, {config}) => {
    const configData = get(config, configPath);
    return dispatch(chartSlice.actions.setChartConfig(stateId, configData));
  };
}
